import {AuthService} from '../../services/authService';
import {Router} from 'aurelia-router';
import { SiteParameterAPI } from '../../services/admin/siteParameterAPI';
import {UserMessageService} from '../../services/userMessageService';
import {inject} from 'aurelia-framework';  

@inject(AuthService, Router, SiteParameterAPI, UserMessageService)
export class TermsConditionsNew {
   
    constructor(authService, router, api, userMessageService) {
        this.authService = authService;
        this.router = router;
        this.api = api;
        this.userMessageService = userMessageService;

        this.url = window.location.origin;
        this.url = this.url.replace(/(^\w+:|^)\/\//, '');
    }

    activate(params, route) {
        console.log("Terms and Conditions: ", params);
        this.load();        
    }

    load() {
        this.api.getPublicTermsConditions( 
            this.getUrl(),
            this.saveLoadSuccess.bind(this), 
            this.saveLoadError.bind(this));
    }

    saveLoadSuccess(data) {
        console.log(data);
        this.setData(data);
    }

    saveLoadError(msg) {
    
        this.sending = false;
        this.saving = false;
        this.deleting = false;
        this.userMessageService.setUserError("user", msg);

    }
        
    setData(data) {
        this.bodyContainer2.innerHTML = data.TERMS_CONDITIONS;        
    }
    
    getData() {

        var data = {
            "privacy_policy": this.bodyContainer2.innerHTML
        }
        console.log("Form data: ",data);
        return data;
    }

    getUrl() {
        var data = {
          "url" : this.url
        }
    
        return data;
    }
}
